import {
  PricePlanLimitedSubscriptionInterface,
  PricePlanSubscriptionInterface,
} from '@systemeio/types'
import React from 'react'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'

interface SubscriptionDescriptionProps {
  subscriptionPricePlan: PricePlanSubscriptionInterface | PricePlanLimitedSubscriptionInterface
  amountWithCurrency: string
  quantity: number
  coupon: {
    innerName: string
  } | null
}
function SubscriptionDescription({
  amountWithCurrency,
  subscriptionPricePlan,
  quantity,
  coupon,
}: SubscriptionDescriptionProps) {
  const { t } = useLocoTranslation()

  return (
    <div className="flex flex-col gap-1">
      <div className="truncate">
        {`${amountWithCurrency} ${t(
          'dashboard.funnel.configuration.common.price_plan.subscription_plan.interval_label',
        )} ${t(
          `dashboard.funnel.configuration.common.price_plan.period.${subscriptionPricePlan.recurringOptions.interval}`,
          {
            count: subscriptionPricePlan.recurringOptions.intervalCount,
          },
        )}`}
      </div>
      {subscriptionPricePlan.recurringOptions.limitOfPayments && (
        <div className="truncate">
          {`${t(
            'dashboard.funnel.configuration.common.price_plan.subscription_plan.limit_of_payments',
          )} : ${subscriptionPricePlan.recurringOptions.limitOfPayments}`}
        </div>
      )}
      {subscriptionPricePlan.recurringOptions.trialPeriod > 0 &&
        subscriptionPricePlan.recurringOptions.trialInterval && (
          <div className="truncate">{`${t(
            'dashboard.funnel.configuration.common.price_plan.subscription_plan.trial_period',
          )} : ${t(
            `dashboard.funnel.configuration.common.price_plan.period.${subscriptionPricePlan.recurringOptions.trialInterval}`,
            {
              count: subscriptionPricePlan.recurringOptions.trialPeriod,
            },
          )}`}</div>
        )}
      {quantity > 1 ? (
        <div className="truncate">{`${t(
          'dashboard.funnel.configuration.common.for_label',
        )} ${quantity} x ${subscriptionPricePlan.innerName}`}</div>
      ) : (
        <div className="truncate">{subscriptionPricePlan.innerName}</div>
      )}
      {coupon && (
        <div className="truncate">
          {`${t('dashboard.funnel.configuration.common.with_the_coupon_label')} `}
          <span className="font-bold">{coupon.innerName}</span>
        </div>
      )}
    </div>
  )
}

export default SubscriptionDescription
